export default __webpack_public_path__ + "104edd7.png";